<template>
    <section class="section icons-section no-padding-top">
        <div class="container">
            <div class="row margin-bottom">
                <div class="col-12">
                    <div class="heading heading--center">
                        <span class="heading__pre-title">Our Activities</span>

                        <h2 class="heading__title">
                            <span>How we help others</span>
                            <br /><span>Build &amp; Sustain Wealth</span>
                        </h2>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-6 col-lg-3">
                    <div class="icon-item">
                        <div class="icon-item__img">
                            <img class="img--layout" src="@/assets/images/icon_1-1.png" alt="img"/>

                            <svg class="icon icon-item__icon icon--red">
                                <use xlink:href="#donation"></use>
                            </svg>
                        </div>
                        <div class="icon-item__text">
                            <p>
                                Promoting the Spread of
                                <br />Crypto Adoption
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-6 col-lg-3">
                    <div class="icon-item">
                        <div class="icon-item__img">
                            <img class="img--layout" src="@/assets/images/icon_2-2.png" alt="img"/>

                            <svg class="icon icon-item__icon icon--orange">
                                <use xlink:href="#church"></use>
                            </svg>
                        </div>
                        <div class="icon-item__text">
                            <p>
                                Developing NEW
                                <br />Tools &amp; Services
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-6 col-lg-3">
                    <div class="icon-item">
                        <div class="icon-item__img">
                            <img class="img--layout" src="@/assets/images/icon_3-3.png" alt="img"/>

                            <svg class="icon icon-item__icon icon--green">
                                <use xlink:href="#blood"></use>
                            </svg>
                        </div>
                        <div class="icon-item__text">
                            <p>
                                Introducing
                                <br />DRIPP Fundraising
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-6 col-lg-3">
                    <div class="icon-item">
                        <div class="icon-item__img">
                            <img class="img--layout" src="@/assets/images/icon_4-4.png" alt="img"/>

                            <svg class="icon icon-item__icon icon--blue">
                                <use xlink:href="#charity"></use>
                            </svg>
                        </div>
                        <div class="icon-item__text">
                            <p>
                                Supporting Global
                                <br />Outreach Programs
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        // msg: String
    }
}
</script>

<style scoped>
/*  */
</style>
